import { saveSteamUserInfoEndpoint, } from 'root/src/server/modules/steam/endpoints/saveSteamUserInfo.endpoint';
export const steamEndpoints = Object.assign({}, saveSteamUserInfoEndpoint);
